<template>
  <cascading-scale-unit-select
    v-if="scope.row.isFieldViewable('scale_unit')"
    v-model="scope.row.model"
    @change="scope.row.save()"
  ></cascading-scale-unit-select>
  <CascadingElementHiddenProp v-else>{{scope.row.getHiddenPlaceholder('scale_unit')}}</CascadingElementHiddenProp>
</template>

<script>

import CascadingScaleUnitSelect from "@/modules/cascading/components/scale/CascadingScaleUnitSelect.vue";
import CascadingElementHiddenProp from "@/modules/cascading/components/CascadingElementHiddenProp.vue";

export default {
  name: 'cascading-element-scale-unit-table-column',
  components: { CascadingElementHiddenProp, CascadingScaleUnitSelect },
  mixins: [],

  props: {
    scope: {type: Object, required: true},
  },
  data() {
    return {}
  },
  methods: {}
}

</script>

<style lang="scss">
@import "@/assets/css/project-variables";

</style>
